export function fiyatFormatla(deger) {
  return deger.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function isaretliFormatla(deger, sonek) {
  const isaret = deger >= 0 ? '+' : '';
  return isaret + deger.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + (sonek || '');
}

// Değişim/fark, isyatirim.com.tr'nin verdiği önceki kapanış (dayClose)
// baz alınarak hesaplanıyor.
export function degisimHesapla(last, dayClose) {
  if (!dayClose) return null;
  const fark = last - dayClose;
  return { fark, yuzde: (fark / dayClose) * 100 };
}
